import type { StatusTone } from '@/components/app/StatusPill';

/**
 * Тон <StatusPill> для статусов домена. Подписи — в labels.ts, здесь только цвет.
 * Неизвестный статус → neutral.
 */
const PAYMENT: Record<string, StatusTone> = {
  success: 'pos',
  initiated: 'warn',
  failed: 'neg',
  expired: 'neutral',
  cancelled: 'neg',
};

const ORDER: Record<string, StatusTone> = {
  paid: 'pos',
  pending: 'warn',
  cancelled: 'neutral',
  refunded: 'neg',
};

const SUBSCRIPTION: Record<string, StatusTone> = {
  active: 'pos',
  expired: 'neutral',
  cancelled: 'neg',
};

const NOTIFICATION: Record<string, StatusTone> = {
  sent: 'pos',
  scheduled: 'info',
  pending: 'warn',
  failed: 'neg',
  cancelled: 'neutral',
};

const pick = (map: Record<string, StatusTone>) => (status: string | null | undefined): StatusTone =>
  (status && map[status]) || 'neutral';

export const paymentStatusTone = pick(PAYMENT);
export const orderStatusTone = pick(ORDER);
export const subscriptionStatusTone = pick(SUBSCRIPTION);
export const notificationStatusTone = pick(NOTIFICATION);
